(function () {
  function init(root) {
    root.querySelectorAll('[data-nk-slider]').forEach(function (s) {
      if (s.dataset.ready) return; s.dataset.ready = '1';
      var track = s.querySelector('.nk-slider__track');
      var step = function () { var c = track.children[0]; return c ? c.getBoundingClientRect().width + 12 : 300; };
      var prev = s.querySelector('[data-nk-prev]'), next = s.querySelector('[data-nk-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
    root.querySelectorAll('[data-nk-tabs]').forEach(function (t) {
      if (t.dataset.ready) return; t.dataset.ready = '1';
      var btns = t.querySelectorAll('[data-nk-tab]'), panels = t.querySelectorAll('[data-nk-panel]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.toggle('is-active', x === b); });
          panels.forEach(function (p) { p.hidden = p.dataset.nkPanel !== b.dataset.nkTab; });
        });
      });
    });
  }
  function money(c) { return '$'  + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function initForms(root) {
    root.querySelectorAll('[data-nk-form]').forEach(function (form) {
      if (form.dataset.ready) return; form.dataset.ready = '1';
      var variants = JSON.parse(form.querySelector('[data-nk-variants]').textContent);
      var groups = form.querySelectorAll('[data-nk-opt]');
      var idInput = form.querySelector('[data-nk-variant-id]');
      var btn = form.querySelector('[data-nk-add]'), hint = form.querySelector('[data-nk-hint]');
      var label = btn.textContent.trim();
      var price = document.querySelector('[data-nk-price]');
      function chosen() { return Array.prototype.map.call(groups, function (g) { var i = g.querySelector('input:checked'); return i ? i.value : null; }); }
      function current() {
        var sel = chosen(); if (sel.indexOf(null) > -1) return null;
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }) || null;
      }
      function update() {
        var v = current();
        groups.forEach(function (g) { if (g.querySelector('input:checked')) g.classList.remove('is-missing'); });
        if (!groups.length || chosen().indexOf(null) === -1) hint.hidden = true;
        if (!v) return;
        idInput.value = v.id;
        btn.disabled = !v.available;
        btn.textContent = v.available ? label : 'Agotado';
        if (price) price.innerHTML = money(v.price) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
      }
      form.addEventListener('change', update);
      update();
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (groups.length && !current()) {
          groups.forEach(function (g) { g.classList.toggle('is-missing', !g.querySelector('input:checked')); });
          hint.hidden = false;
          var first = form.querySelector('.is-missing'); if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Añadiendo…';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
          .then(function () { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
          .catch(function (err) {
            btn.removeAttribute('aria-busy'); btn.textContent = label;
            hint.textContent = (err && (err.description || err.message)) || 'No se pudo añadir al carrito. Inténtalo de nuevo.';
            hint.hidden = false;
          });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); initForms(document); });
  else { init(document); initForms(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initForms(e.target); });
})();
